import React from "react";

import Quiz from './Quiz'

export default function QuizBox() {

  return (
    <section className="home-hero">
	    <div className="container">
	
            <div className="row clear">
                <div className="shadow-box-curved col-md-8 col-md-offset-2">
                    <Quiz />
                </div> 
            </div> 
        </div>
    </section>
  );
}
